import { SubmissionState } from '.';

const submitAttempting = (state: SubmissionState): boolean => state.actions.submit || false;
const hasSubmitted = (state: SubmissionState): boolean => state.hasSubmitted || false;

export default {
    submitAttempting,
    hasSubmitted,
};
